import { render, staticRenderFns } from "./sk-folding-cube.vue?vue&type=template&id=18485fe8&scoped=true&"
import script from "./sk-folding-cube.vue?vue&type=script&lang=js&"
export * from "./sk-folding-cube.vue?vue&type=script&lang=js&"
import style0 from "./sk-folding-cube.vue?vue&type=style&index=0&id=18485fe8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18485fe8",
  null
  
)

export default component.exports